import { createContext } from 'react';

export type SettingsContextType = {
  reload: () => Promise<void>;
};

export const SettingsContext = createContext<SettingsContextType>({} as any);
